import { environment } from './../../environments/environment';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { CursosService } from './cursos/shared/cursos.service';

import { GraduacaoRouter } from './graduacao.router';
import { GraduacaoComponent } from './graduacao.component';
import { CursosComponent } from './cursos/cursos.component';
import { CursoDetalheComponent } from './cursos/curso-detalhe/curso-detalhe.component';
import { EnadeComponent } from './enade/enade.component';
import { CondicoesOfertaCursoComponent } from './condicoes-oferta-curso/condicoes-oferta-curso.component';
import { ValidaDocumentosComponent } from './valida-documentos/valida-documentos.component';
import { ConsultaEmailComponent } from './consulta-email/consulta-email.component';

import { VestibularService } from 'app/vestibular/shared/vestibular.service';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { fiesProuniComponent } from './fies-prouni/fies-prouni.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    GraduacaoRouter,
    ReCaptchaModule,
  ],
  providers: [ CursosService, VestibularService ],
  declarations: [
    GraduacaoComponent,
    CursosComponent,
    CursoDetalheComponent,
    EnadeComponent,
    CondicoesOfertaCursoComponent,
    ValidaDocumentosComponent,
    ConsultaEmailComponent,
    fiesProuniComponent,
  ],
})
export class GraduacaoModule { }
